import React, { useState } from "react";
import { jsPDF } from "jspdf";

export default function DailyReports({ onClose }) {
  // TEXT INPUTS
  const [customer, setCustomer] = useState("");
  const [address, setAddress] = useState("");
  const [projectNumber, setProjectNumber] = useState("");
  const [acInstallation, setAcInstallation] = useState("");
  const [speicher, setSpeicher] = useState("");
  const [wallbox, setWallbox] = useState("");
  const [backupBox, setBackupBox] = useState("");
  const [tiefenrder, setTiefenrder] = useState("No");
  const [status, setStatus] = useState("All finished");
  const [oldFusebox, setOldFusebox] = useState("");
  const [kabelKanal, setKabelKanal] = useState("");
  const [pvcRohr, setPvcRohr] = useState("");
  const [erdung16, setErdung16] = useState("");
  const [erdung10, setErdung10] = useState("");
  const [kabel516, setKabel516] = useState("");
  const [kabel510, setKabel510] = useState("");
  const [kabel56, setKabel56] = useState("");
  const [cat7, setCat7] = useState("");
  const [note, setNote] = useState("");

  // QUANTITIES WITH +/-
  const createCounter = () => useState(0);
  const [internalCounter, setInternalCounter] = createCounter();
  const [sls50a, setSls50a] = createCounter();
  const [uss, setUss] = createCounter();
  const [spannungsversorgung, setSpannungsversorgung] = createCounter();
  const [lasttrennschalt, setLasttrennschalt] = createCounter();
  const [einspeiseadapter, setEinspeiseadapter] = createCounter();
  const [ehzPlate, setEhzPlate] = createCounter();
  const [okk, setOkk] = createCounter();
  const [fi40a300, setFi40a300] = createCounter();
  const [fi40a30, setFi40a30] = createCounter();
  const [fi16a30, setFi16a30] = createCounter();
  const [b32a3p, setB32a3p] = createCounter();
  const [smartMeter, setSmartMeter] = createCounter();
  const [hauptschalter, setHauptschalter] = createCounter();
  const [klemme5p, setKlemme5p] = createCounter();
  const [klemme1p, setKlemme1p] = createCounter();
  const [patch1m, setPatch1m] = createCounter();
  const [patch5m, setPatch5m] = createCounter();
  const [patch10m, setPatch10m] = createCounter();
  const [powerSwitch, setPowerSwitch] = createCounter();
  const [powerLine, setPowerLine] = createCounter();
  const [connectionBox516, setConnectionBox516] = createCounter();
  const [potischine, setPotischine] = createCounter();

  const handleCopy = () => {
    const text = `
Customer: ${customer}
Address: ${address}
Project Number: ${projectNumber}
AC-Installation: ${acInstallation}
Speicher: ${speicher}
Wallbox: ${wallbox}
Backup Box: ${backupBox}
Tiefenrder set: ${tiefenrder}
Status: ${status}

Internal counter: ${internalCounter} pc
SLS 50A: ${sls50a} pc
USS: ${uss} pc
Spannungsversorgung APZ und RfZ: ${spannungsversorgung} pc
Lasttrennschalt: ${lasttrennschalt} pc
Einspeiseadapter: ${einspeiseadapter} pc
EHZ Plate: ${ehzPlate} pc
OKK: ${okk} pc
Fi40A 300mA: ${fi40a300} pc
Fi40A 30mA: ${fi40a30} pc
Fi16A 30mA: ${fi16a30} pc
B32A 3P: ${b32a3p} pc
Smart Meter: ${smartMeter} pc
Hauptschalter: ${hauptschalter} pc
Klemme 5P: ${klemme5p} pc
Klemme 1P: ${klemme1p} pc
Patch Kabel 1m: ${patch1m} pc
Patch Kabel 5m: ${patch5m} pc
Patch Kabel 10m: ${patch10m} pc
Power Switch: ${powerSwitch} pc
PowerLine: ${powerLine} pc
Old Fusebox: ${oldFusebox}
Connection box 5x16: ${connectionBox516} pc
Potischine: ${potischine} pc
Kabel Kanal 60x40: ${kabelKanal} m
PVC Rohr fi32: ${pvcRohr} m
Erdung 1x16: ${erdung16} m
Erdung 1x10: ${erdung10} m
Kabel 5x16: ${kabel516} m
Kabel 5x10: ${kabel510} m
Kabel 5x6: ${kabel56} m
Cat7: ${cat7} m
NOTE: ${note}
    `;
    navigator.clipboard.writeText(text);
    alert("Copied all data!");
  };

  const handlePDF = () => {
    const doc = new jsPDF();
    doc.text("Daily Report", 10, 10);
    doc.text(`Customer: ${customer}`, 10, 20);
    doc.text(`Address: ${address}`, 10, 30);
    // ... možeš dodati i sve ostalo po linijama
    doc.save("daily_report.pdf");
  };

  const counters = [
    { label: "Internal counter", state: internalCounter, setter: setInternalCounter },
    { label: "SLS 50A", state: sls50a, setter: setSls50a },
    { label: "USS", state: uss, setter: setUss },
    { label: "Spannungsversorgung APZ und RfZ", state: spannungsversorgung, setter: setSpannungsversorgung },
    { label: "Lasttrennschalt", state: lasttrennschalt, setter: setLasttrennschalt },
    { label: "Einspeiseadapter", state: einspeiseadapter, setter: setEinspeiseadapter },
    { label: "EHZ Plate", state: ehzPlate, setter: setEhzPlate },
    { label: "OKK", state: okk, setter: setOkk },
    { label: "Fi40A 300mA", state: fi40a300, setter: setFi40a300 },
    { label: "Fi40A 30mA", state: fi40a30, setter: setFi40a30 },
    { label: "Fi16A 30mA", state: fi16a30, setter: setFi16a30 },
    { label: "B32A 3P", state: b32a3p, setter: setB32a3p },
    { label: "Smart Meter", state: smartMeter, setter: setSmartMeter },
    { label: "Hauptschalter", state: hauptschalter, setter: setHauptschalter },
    { label: "Klemme 5P", state: klemme5p, setter: setKlemme5p },
    { label: "Klemme 1P", state: klemme1p, setter: setKlemme1p },
    { label: "Patch Kabel 1m", state: patch1m, setter: setPatch1m },
    { label: "Patch Kabel 5m", state: patch5m, setter: setPatch5m },
    { label: "Patch Kabel 10m", state: patch10m, setter: setPatch10m },
    { label: "Power Switch", state: powerSwitch, setter: setPowerSwitch },
    { label: "PowerLine", state: powerLine, setter: setPowerLine },
    { label: "Connection box 5x16", state: connectionBox516, setter: setConnectionBox516 },
    { label: "Potischine", state: potischine, setter: setPotischine },
  ];

  return (
   <div className="fixed inset-0 bg-blue-100/30 backdrop-blur-md flex items-center justify-center p-4 z-50 overflow-auto">
  <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-5xl max-h-[90vh] overflow-y-auto relative">

        <h2 className="text-xl font-bold mb-4">Daily Report</h2>
        <button
          onClick={onClose}
          className="absolute top-4 right-4 bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
        >
          Close
        </button>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <label>
            Customer:
            <input
              value={customer}
              onChange={(e) => setCustomer(e.target.value)}
              className="w-full border rounded p-2"
            />
          </label>
          <label>
            Address:
            <input
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              className="w-full border rounded p-2"
            />
          </label>
          <label>
            Project Number:
            <input
              value={projectNumber}
              onChange={(e) => setProjectNumber(e.target.value)}
              className="w-full border rounded p-2"
            />
          </label>
          <label>
            AC-Installation:
            <input
              value={acInstallation}
              onChange={(e) => setAcInstallation(e.target.value)}
              className="w-full border rounded p-2"
            />
          </label>
          <label>
            Speicher:
            <input
              value={speicher}
              onChange={(e) => setSpeicher(e.target.value)}
              className="w-full border rounded p-2"
            />
          </label>
          <label>
            Wallbox:
            <input
              value={wallbox}
              onChange={(e) => setWallbox(e.target.value)}
              className="w-full border rounded p-2"
            />
          </label>
          <label>
            Backup Box:
            <input
              value={backupBox}
              onChange={(e) => setBackupBox(e.target.value)}
              className="w-full border rounded p-2"
            />
          </label>
          <div>
            <label className="block font-medium mb-1">Tiefenrder set:</label>
            <select
              value={tiefenrder}
              onChange={(e) => setTiefenrder(e.target.value)}
              className="w-full border rounded p-2"
            >
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </div>
          <div>
            <label className="block font-medium mb-1">Status:</label>
            <select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              className="w-full border rounded p-2"
            >
              <option value="All finished">All finished</option>
              <option value="No Finished">No Finished</option>
            </select>
          </div>
        </div>

        {/* COUNTERS */}
        <div className="mt-6">
          <h3 className="font-bold mb-2">Material Quantities</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {counters.map((item) => (
              <div key={item.label} className="flex items-center justify-between border p-2 rounded">
                <span className="font-medium">{item.label}:</span>
                <div className="flex items-center gap-2">
                  <button
                    onClick={() => item.setter(item.state > 0 ? item.state - 1 : 0)}
                    className="bg-red-500 text-white px-2 py-1 rounded hover:bg-red-600"
                  >
                    -
                  </button>
                  <span>{item.state} pc</span>
                  <button
                    onClick={() => item.setter(item.state + 1)}
                    className="bg-green-500 text-white px-2 py-1 rounded hover:bg-green-600"
                  >
                    +
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-6 flex gap-2">
          <button
            onClick={handleCopy}
            className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
          >
            Copy All Data
          </button>
          <button
            onClick={handlePDF}
            className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
          >
            Export PDF
          </button>
        </div>
      </div>
    </div>
  );
}
